import React from "react";

const CloseIcon: React.FunctionComponent = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.24921 0.594416L2.34421 0.678302L6.62268 4.95693L10.9012 0.678302C11.295 0.284479 11.9335 0.284479 12.3273 0.678302C12.6908 1.04183 12.7188 1.61386 12.4112 2.00946L12.3273 2.10446L8.04868 6.38294L12.3273 10.6614C12.7211 11.0552 12.7211 11.6938 12.3273 12.0876C11.9638 12.4511 11.3918 12.4791 10.9962 12.1715L10.9012 12.0876L6.62268 7.80894L2.34421 12.0876C1.95039 12.4814 1.31187 12.4814 0.918049 12.0876C0.55452 11.724 0.526555 11.152 0.834156 10.7564L0.918049 10.6614L5.19669 6.38294L0.918049 2.10446C0.524226 1.71064 0.524226 1.07212 0.918049 0.678302C1.28158 0.314773 1.85361 0.286815 2.24921 0.594416Z"
      fill="black"
    />
  </svg>
);

export default React.memo(CloseIcon);
